/* The marketplace's shared pieces: the category strip, the five steps, where
   Get started goes, and the styles for the browse pages and their green header
   (pages/MarketHome, components/MarketHeader, the post and category pages). */

export const CATEGORIES = [
  // `q` feeds the public search endpoints, which OR the words together across
  // title, description, offering, vertical and location. So a category is a
  // handful of words that catch its listings, not an exact vertical: postings
  // carry free-text titles, and the vertical choices do not cover warehouse,
  // drivers or customer service at all.
  { key: "all", label: "All", icon: "squares-four", q: "" },
  { key: "healthcare", label: "Healthcare", icon: "stethoscope", q: "healthcare nurse medical CNA caregiver" },
  { key: "warehouse", label: "Warehouse", icon: "package", q: "warehouse forklift picker packer" },
  { key: "drivers", label: "Drivers", icon: "truck", q: "driver delivery CDL trucking" },
  { key: "service", label: "Customer service", icon: "headset", q: "customer service support call" },
  { key: "trades", label: "Trades", icon: "hammer", q: "electrician electrical plumber plumbing HVAC carpenter roofing roofer renovation remodeling trades" },
  { key: "office", label: "Office", icon: "clipboard-text", q: "administrative office receptionist assistant consulting legal professional" },
  { key: "home", label: "Home services", icon: "house-line", q: "cleaning cleaner landscaping housekeeping lawn moving movers pest" },
  { key: "finance", label: "Finance", icon: "chart-line-up", q: "bookkeeping accounting finance" },
  { key: "fractional", label: "Fractional", icon: "briefcase", q: "fractional consultant" },
];

export const STEPS = [
  ["Post what you need", "or reply to a post"],
  ["Agree on terms", "rate, dates, W-2 or 1099"],
  ["Schedule the work", "shifts on one calendar"],
  ["Approve and pay", "timecards in, pay out"],
  ["See your numbers", "hours, spend, 1099s"],
];

// Every "Get started" here opens the free-form "What can we help you with?"
// box (CompanyAsk) directly, not the company-or-individual cards. The box reads
// what they type and sends anyone looking for work to the individual side, so
// it fits everybody who lands on this page (owner's call, 2026-10-31).
export const ASK_PATH = "/get-started?a=business&c=1";

export const CHEV_BG = ["#F1F6F3", "#E3EEE8", "#D4E6DC", "#C4DDCF", "#B3D3C2"];

export const MARKET_CSS = `
.mh{background:#FFFFFF;color:#1F1B16;font-family:var(--font-sans)}
.mh-page{min-height:100vh}
.mh a{color:inherit;text-decoration:none}
.mh button{font-family:inherit;cursor:pointer}
.mh-sr{position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap}
.mh-wrap{max-width:1440px;margin:0 auto;padding:0 40px;box-sizing:border-box}
.mh-grow{flex:1}

.mh-head{background:#0F4A39;color:#F6F1E4}
.mh-bar{display:flex;align-items:center;gap:32px;min-height:76px;padding-top:12px;padding-bottom:12px}
.mh-logo{font-size:18px;font-weight:600;letter-spacing:-.01em;white-space:nowrap;color:#F6F1E4!important}
.mh-search{flex:0 1 780px;min-width:0;height:48px;display:flex;align-items:stretch;background:#FFFFFF;border-radius:12px;overflow:hidden}
.mh-show{display:flex;align-items:center;padding:0 8px 0 12px;background:#EFE9DF;border-right:1px solid rgba(31,27,22,.08)}
.mh-show select{border:0;background:transparent;font:inherit;font-size:14px;color:#1F1B16;cursor:pointer;outline-offset:2px}
.mh-field{display:flex;align-items:center;gap:8px;padding:0 16px;flex:1 1 0;min-width:0;color:#7B7266}
.mh-field-what{flex:1.6 1 0}
.mh-field-where{border-left:1px solid rgba(31,27,22,.08)}
.mh-field input{border:0;outline:none;background:transparent;font:inherit;font-size:14px;color:#1F1B16;min-width:0;width:100%}
.mh-field input::placeholder{color:#7B7266}
.mh-search:focus-within{box-shadow:0 0 0 2px #E3C77E}
.mh-search-body{display:none}
.mh-go{flex:0 0 auto;width:56px;border:0;background:#E3C77E;color:#1F1B16;display:grid;place-items:center;transition:background-color .15s cubic-bezier(.22,1,.36,1)}
.mh-go:hover{background:#D9BA68}
.mh-acct{margin-left:auto;display:flex;align-items:center;gap:24px;font-size:14px;white-space:nowrap}
.mh-acct-link{color:#C9DBD1!important}
.mh-acct-link:hover{color:#F6F1E4!important}
.mh-btn{display:inline-flex;align-items:center;justify-content:center;height:36px;padding:0 16px;border-radius:8px;font-size:14px;font-weight:500;white-space:nowrap;transition:background-color .15s cubic-bezier(.22,1,.36,1),border-color .15s cubic-bezier(.22,1,.36,1)}
.mh-btn-cream{background:#F6F1E4;color:#0F4A39!important}
.mh-btn-cream:hover{background:#FFFFFF}
.mh-btn-green{background:#15604A;color:#FFFFFF!important;height:44px;padding:0 20px}
.mh-btn-line{border:1px solid #CFC8BC;background:#FFFFFF;color:#1F1B16}
.mh-btn-line:hover{border-color:#15604A}

.mh-catband{background:#0A3328}
.mh-cats{display:flex;gap:40px;overflow-x:auto;scrollbar-width:none}
.mh-cats::-webkit-scrollbar{display:none}
.mh-cat{display:flex;flex-direction:column;align-items:center;gap:8px;padding:12px 0 10px;white-space:nowrap;font-size:13px;font-weight:500;color:#A9C4B8;background:none;border:0;border-bottom:2px solid transparent;transition:color .15s cubic-bezier(.22,1,.36,1)}
.mh-cat:hover{color:#F6F1E4}
.mh-cat.on{color:#F6F1E4;border-bottom-color:#F6F1E4}
.mh-catpick{display:none}
.mh-catpick-btn{display:flex;align-items:center;gap:12px;width:100%;height:52px;border:0;background:none;padding:0;color:#F6F1E4;font-size:16px;font-weight:500;text-align:left}
.mh-catlist{list-style:none;margin:0;padding:0 0 8px;border-top:1px solid rgba(246,241,228,.12)}
.mh-catlist button{display:flex;align-items:center;gap:12px;width:100%;height:48px;border:0;background:none;padding:0;color:#C9DBD1;font-size:16px;text-align:left}
.mh-catlist button.on{color:#F6F1E4;font-weight:500}

.mh-how{background:#FFFFFF;border-bottom:1px solid #E8E4DC}
.mh-how-in{display:flex;align-items:center;gap:40px;padding-top:20px;padding-bottom:20px}
.mh-how-label{margin:0;flex:0 0 230px;font-size:15px;font-weight:500;line-height:22px}
.mh-how-label span{display:block;font-weight:400;font-size:13px;color:#7B7266}
.mh-chev{list-style:none;margin:0;padding:0;flex:1 1 auto;display:flex;min-width:0}
.mh-chev li{flex:1 1 0;min-width:0;height:64px;margin-left:-14px;padding:0 28px 0 34px;display:flex;align-items:center;gap:12px;clip-path:polygon(0 0,calc(100% - 18px) 0,100% 50%,calc(100% - 18px) 100%,0 100%,18px 50%)}
.mh-chev li:first-child{margin-left:0;padding-left:20px;clip-path:polygon(0 0,calc(100% - 18px) 0,100% 50%,calc(100% - 18px) 100%,0 100%)}
.mh-chev-n{color:#0F4A39;font-size:15px;font-weight:600}
.mh-chev-t{display:flex;flex-direction:column;min-width:0;font-size:15px;font-weight:500;line-height:20px;white-space:nowrap}
.mh-chev-t span{font-size:13px;font-weight:400;line-height:18px;color:#4F5A53;overflow:hidden;text-overflow:ellipsis}

.mh-main{display:flex;gap:40px;align-items:flex-start;padding-top:40px;padding-bottom:96px}
.mh-filters{flex:0 0 264px;background:#FFFFFF;border:1px solid #E8E4DC;border-radius:14px;overflow:hidden;position:sticky;top:16px}
.mh-fhead{display:flex;align-items:center;justify-content:space-between;padding:16px 20px;border-bottom:1px solid #E8E4DC;font-size:15px;font-weight:600}
.mh-fhead button{border:0;background:none;font-size:13px;font-weight:400;color:#15604A;padding:0}
.mh-fsec{padding:20px;border-bottom:1px solid #E8E4DC;margin:0}
.mh-fsec-last{border-bottom:0}
.mh-fh{margin:0 0 12px;font-size:13px;line-height:18px;font-weight:600}
.mh-frow{display:flex;align-items:center;gap:10px;height:36px;padding:0 8px;margin:0 -8px;border-radius:8px;font-size:14px;cursor:pointer;position:relative}
.mh-frow:hover{background:#F5F2EC}
.mh-frow input{position:absolute;opacity:0;width:1px;height:1px}
.mh-fbox{width:18px;height:18px;border-radius:4px;border:1.5px solid #B8B0A3;display:grid;place-items:center;box-sizing:border-box;flex:0 0 auto;color:transparent}
.mh-frow input:checked + .mh-fbox{background:#15604A;border-color:#15604A;color:#FFFFFF}
.mh-frow input:focus-visible + .mh-fbox{outline:2px solid #15604A;outline-offset:2px}
.mh-fcount{font-size:13px;color:#7B7266;font-variant-numeric:tabular-nums}
.mh-chips{display:flex;flex-wrap:wrap;gap:8px}
.mh-chip{display:inline-flex;align-items:center;height:32px;padding:0 12px;border:1px solid #D9D3C8;border-radius:8px;font-size:13px;color:#1F1B16;background:#FFFFFF}
.mh-chip.on{background:#EAF1ED;border-color:#15604A;color:#0F4A39;font-weight:500}
.mh-input{display:flex;align-items:center;gap:8px;height:40px;padding:0 12px;border:1px solid #D9D3C8;border-radius:8px;color:#7B7266}
.mh-input:focus-within{border-color:#15604A}
.mh-input input{border:0;outline:none;font:inherit;font-size:14px;color:#1F1B16;min-width:0;width:100%;background:transparent}
.mh-fnote{margin:8px 0 0;font-size:13px;line-height:18px;color:#7B7266}
.mh-flink{display:inline-block;margin-top:12px;font-size:14px;font-weight:500;color:#15604A!important}

.mh-results{flex:1 1 auto;min-width:0}
.mh-rhead{margin-bottom:20px}
.mh-title-link{display:inline-flex;align-items:center;gap:10px}
.mh-title-link svg{color:#15604A;transition:transform .15s cubic-bezier(.22,1,.36,1)}
.mh-title-link:hover{color:#15604A}
.mh-title-link:hover svg{transform:translateX(3px)}
.mh-rhead-row{display:flex;align-items:baseline;justify-content:space-between;gap:16px}
.mh-howlink{display:none;border:0;background:none;padding:0;font-size:14px;font-weight:500;color:#15604A;text-decoration:underline;text-underline-offset:3px;white-space:nowrap}
.mh-burger{display:none;width:40px;height:40px;border:0;border-radius:8px;background:transparent;color:#F6F1E4;place-items:center}
.mh-menu{display:none}
.mh-pop-scrim{position:fixed;inset:0;z-index:60;background:rgba(31,27,22,.45);display:grid;place-items:center;padding:16px}
.mh-pop-backdrop{position:absolute;inset:0;border:0;background:transparent;cursor:default}
.mh-pop{position:relative;width:100%;max-width:420px;max-height:calc(100vh - 32px);overflow:auto;background:#FFFFFF;border-radius:16px;padding:24px;box-sizing:border-box;box-shadow:0 24px 64px rgba(0,0,0,.18)}
.mh-pop-head{display:flex;align-items:center;justify-content:space-between;gap:12px}
.mh-pop-head h2{margin:0;font-size:20px;line-height:1.25;font-weight:600}
.mh-pop-head button{border:0;background:#F5F2EC;width:36px;height:36px;border-radius:8px;display:grid;place-items:center;color:#1F1B16}
.mh-pop-sub{margin:6px 0 20px;font-size:14px;line-height:20px;color:#5E554A}
.mh-vchev{list-style:none;margin:0;padding:0;display:flex;flex-direction:column}
.mh-vchev li{display:flex;align-items:center;gap:12px;padding:22px 20px 26px;margin-top:-10px;clip-path:polygon(0 0,50% 12px,100% 0,100% calc(100% - 12px),50% 100%,0 calc(100% - 12px))}
.mh-vchev li:first-child{margin-top:0;padding-top:12px;clip-path:polygon(0 0,100% 0,100% calc(100% - 12px),50% 100%,0 calc(100% - 12px))}
.mh-pop-cta{display:flex;width:100%;margin-top:20px;box-sizing:border-box}
.mh-rhead h1{margin:0;font-size:28px;line-height:1.15;font-weight:500;letter-spacing:-.02em}
.mh-rhead p{margin:6px 0 0;font-size:15px;line-height:22px;color:#5E554A;max-width:68ch}
.mh-more{display:flex;justify-content:center;margin-top:40px}
.mh-more .mh-btn{height:44px;padding:0 20px}
.mh-empty{padding:48px 0;color:#5E554A;font-size:15px}
.mh-empty p{margin:0 0 8px}
.mh-empty button{border:0;background:none;padding:0;color:#15604A;text-decoration:underline}
.mh-doors{display:flex;flex-wrap:wrap;gap:12px;margin-top:12px}
.mh-doors .mh-btn{height:44px;padding:0 20px}

@media (max-width:1100px){
  .mh-how-label{display:none}
  .mh-hide-sm{display:none}
}
@media (max-width:860px){
  .mh-wrap{padding:0 16px}
  .mh-bar{flex-wrap:wrap;gap:12px 16px}
  .mh-search-head{display:none}
  .mh-search-body{display:flex;margin-top:16px;padding-top:16px;border-top:1px solid #E8E4DC;background:none;border-radius:0;overflow:visible;height:auto}
  .mh-search-body:focus-within{box-shadow:none}
  .mh-search-body .mh-show{border:1px solid #D9D3C8;border-right:0;border-radius:12px 0 0 12px;height:48px;box-sizing:border-box}
  .mh-search-body .mh-field-what{border-top:1px solid #D9D3C8;border-bottom:1px solid #D9D3C8;height:48px;box-sizing:border-box;background:#FFFFFF}
  .mh-search-body .mh-go{border-radius:0 12px 12px 0;height:48px}
  .mh-field-where{display:none}
  .mh-cats{display:none}
  .mh-catpick{display:block}
  .mh-how{display:none}
  .mh-howlink{display:inline}
  .mh-hide-phone{display:none}
  .mh-burger{display:grid}
  .mh-acct{gap:8px}
  .mh-menu{display:flex;flex-direction:column;background:#0F4A39;border-top:1px solid rgba(246,241,228,.12);padding:4px 16px 12px}
  .mh-menu a,.mh-menu button{display:flex;align-items:center;height:48px;border:0;background:none;padding:0;font-size:16px;color:#F6F1E4!important;text-align:left;border-bottom:1px solid rgba(246,241,228,.1)}
  .mh-menu a:last-child{border-bottom:0}
  .mh-rhead h1{font-size:24px}
  .mh-rhead p{display:none}
  .mh-main{flex-direction:column;gap:16px;padding-top:20px}
  .mh-filters{display:none}
}
`;

// The detail pages (a post, a person's profile, a company's storefront): the
// hero, the action panel on the right, the facts and related rows.
export const DETAIL_CSS = `
.pd-main{padding-top:24px;padding-bottom:96px}
.pd-back{display:inline-flex;align-items:center;gap:6px;font-size:14px;color:#5E554A!important;margin-bottom:20px}
.pd-back:hover{color:#15604A!important}
.pd-grid{display:grid;grid-template-columns:minmax(0,1fr) 380px;grid-template-rows:auto 1fr;grid-template-areas:"hero side" "details side";gap:32px 48px;align-items:start}
.pd-hero{grid-area:hero;display:flex;gap:20px}
.pd-side{grid-area:side;position:sticky;top:16px;display:flex;flex-direction:column;gap:12px}
.pd-details{grid-area:details;border-top:1px solid #E8E4DC;padding-top:24px}
.pd-av{flex:0 0 auto;width:88px;height:88px;object-fit:cover;background:#E8E4DC;display:block}
.pd-av-ini{display:grid;place-items:center;color:#3D3833;font-size:26px;font-weight:500}
.pd-hero-body{flex:1 1 auto;min-width:0;display:flex;flex-direction:column;gap:6px}
.pd-title{margin:0;font-size:34px;line-height:1.12;font-weight:600;letter-spacing:-.02em}
.pd-meta{margin:0;font-size:16px;line-height:24px}
.pd-meta a{color:#15604A!important;font-weight:500}
.pd-muted{margin:0;font-size:14px;line-height:20px;color:#5E554A}
.pd-days{margin:4px 0 0;display:inline-flex;align-items:center;gap:8px;font-size:14px;color:#5E554A}
.pd-restrict{margin:8px 0 0;display:inline-flex;align-items:center;gap:6px;font-size:14px;color:#8A5A12}
.pd-panel{border:1px solid #E8E4DC;border-radius:16px;padding:24px;background:#FFFFFF;display:flex;flex-direction:column;gap:12px}
.pd-panel-h{margin:0;font-size:18px;line-height:24px;font-weight:600}
.pd-key{display:flex;align-items:baseline;gap:8px;padding-bottom:12px;border-bottom:1px solid #E8E4DC}
.pd-key span{font-size:28px;line-height:1;font-weight:600;font-variant-numeric:tabular-nums}
.pd-key small{font-size:14px;color:#7B7266}
.pd-note{margin:0;padding:10px 12px;border-radius:8px;background:#EAF1ED;color:#0F4A39;font-size:14px}
.pd-field{display:flex;flex-direction:column;gap:6px;font-size:13px;font-weight:600}
.pd-field em{font-style:normal;color:#B42318}
.pd-field input,.pd-field select,.pd-field textarea{font:inherit;font-weight:400;font-size:15px;color:#1F1B16;border:1px solid #D9D3C8;border-radius:8px;padding:10px 12px;background:#FFFFFF;width:100%;box-sizing:border-box}
.pd-field input:focus,.pd-field select:focus,.pd-field textarea:focus{outline:none;border-color:#15604A;box-shadow:0 0 0 3px rgba(21,96,74,.15)}
.pd-check{display:flex;gap:8px;align-items:flex-start;font-size:13px;color:#5E554A}
.pd-err{margin:0;font-size:14px;color:#B42318}
.pd-send{width:100%;box-sizing:border-box;height:48px!important;font-size:15px!important}
.pd-send:disabled{opacity:.5;cursor:not-allowed}
.pd-sent{align-items:flex-start;color:#0F4A39;background:#EAF1ED;border-color:#CFE3D7}
.pd-profile{font-size:14px;font-weight:500;color:#15604A!important;text-align:center}
.pd-h2{margin:0 0 12px;font-size:20px;line-height:1.25;font-weight:600}
.pd-desc{margin:0 0 24px;font-size:16px;line-height:26px;color:#3D3833;white-space:pre-wrap}
.pd-facts{margin:0 0 24px;display:grid;grid-template-columns:repeat(auto-fill,minmax(200px,1fr));gap:16px 24px}
.pd-facts dt{font-size:13px;color:#7B7266}
.pd-facts dd{margin:2px 0 0;font-size:15px;font-weight:500}
.pd-report{border:0;background:none;padding:0;font-size:13px;color:#7B7266;text-decoration:underline;text-underline-offset:3px}
.pd-reportbox{display:flex;flex-direction:column;gap:12px;max-width:420px}
.pd-row-end{display:flex;justify-content:flex-end;align-items:center;gap:16px}
.pd-related{margin-top:56px}
.pd-stats{margin:6px 0 0;font-size:14px;line-height:20px;color:#3D3833}
.pd-links{display:flex;justify-content:center;gap:20px;margin:0;font-size:14px}
.pd-links a{color:#15604A!important;font-weight:500}
.pd-chips{display:flex;flex-wrap:wrap;gap:8px;margin:0 0 24px}
.pd-chips a,.pd-chips span{display:inline-flex;align-items:center;height:32px;padding:0 12px;border:1px solid #D9D3C8;border-radius:8px;font-size:14px;color:#1F1B16}
.pd-chips a:hover{border-color:#15604A;color:#15604A}
.pd-chips button{display:inline-flex;align-items:center;height:36px;padding:0 14px;border:1px solid #D9D3C8;border-radius:8px;font-size:14px;color:#1F1B16;background:#FFFFFF;font-family:inherit;cursor:pointer}
.pd-chips button[aria-pressed="true"]{background:#EAF1ED;border-color:#15604A;color:#0F4A39;font-weight:500}
.pd-ownstats{display:grid;grid-template-columns:1fr 1fr;gap:8px}
.pd-ownstats div{background:#F7F4EE;border-radius:10px;padding:10px 12px;display:flex;flex-direction:column}
.pd-ownstats span{font-size:22px;font-weight:600;font-variant-numeric:tabular-nums}
.pd-ownstats small{font-size:12px;color:#7B7266}
.pd-copy{display:flex;gap:8px}
.pd-copy input{flex:1;min-width:0;font:inherit;font-size:13px;border:1px solid #D9D3C8;border-radius:8px;padding:8px 10px;background:#F7F4EE}
.pd-missing{border:1px solid #E3C77E;background:#FBF5E6;border-radius:10px;padding:12px 14px}
.pd-missing p{margin:0;font-size:13px;font-weight:600}
.pd-missing ul{margin:6px 0 0;padding:0;list-style:none;display:flex;flex-direction:column;gap:4px}
.pd-missing a{font-size:13px;color:#15604A!important;text-decoration:underline}
.pd-attached{margin:0;font-size:13px;color:#5E554A}
.pd-fine{margin:0;font-size:12px;line-height:16px;color:#7B7266;text-align:center}
.pd-gone-h{margin:24px 0 8px;font-size:28px;font-weight:600}
.pd-draft{background:#F7F4EE;border-radius:10px;padding:14px 16px;margin-bottom:16px;font-size:14px;line-height:20px}
.pd-draft p{margin:0}
.pd-draft-to{color:#7B7266;font-size:12px;margin-bottom:6px!important}
.pd-gate-btn{display:flex;width:100%;height:48px!important;box-sizing:border-box}
.pd-gate-alt{margin:14px 0 0;font-size:14px;color:#5E554A;text-align:center}
.pd-gate-alt a{color:#15604A!important;font-weight:500}
.pd-gate-fine{margin:8px 0 0;font-size:13px;color:#7B7266;text-align:center}
@media (max-width:860px){
  .pd-grid{grid-template-columns:minmax(0,1fr);grid-template-areas:"hero" "side" "details";gap:24px}
  .pd-side{position:static}
  .pd-av{width:64px;height:64px}
  .pd-av-ini{font-size:20px}
  .pd-title{font-size:26px}
}
`;
